// extracted by mini-css-extract-plugin
export default {"wrap":"sI-z","fullWidth":"tI-z","hideOnDesktop":"uI-z","content":"vI-z","hasOpenedNav":"wI-z","crumbsList":"xI-z","dropdownsWrap":"yI-z"};